import { Decimal } from 'decimal.js-light';
import { RoundDamperBlades, UserInput } from 'src/actuators/user-input/types.ts';
import { ActuatorTypes, QueryParams, TorqueLevel } from 'src/actuators/user-input/calculations/constants.ts';

export const detectTorqueLevel = (diameter: string, safety: string, blade: RoundDamperBlades): TorqueLevel => {
    const diameterDecimal = new Decimal(diameter);
    const safetyDecimal = new Decimal(safety);
    if (blade === RoundDamperBlades.BladeWithSeals) {
        if (safetyDecimal.lessThanOrEqualTo(20)) {
            return diameterDecimal.lessThanOrEqualTo(315) ? TorqueLevel.Low : TorqueLevel.High;
        }
        return diameterDecimal.lessThanOrEqualTo(280) ? TorqueLevel.Low : TorqueLevel.High;
    }
    if (safetyDecimal.lessThanOrEqualTo(20)) {
        return diameterDecimal.lessThanOrEqualTo(200) ? TorqueLevel.Low : TorqueLevel.High;
    }
    return diameterDecimal.lessThanOrEqualTo(160) ? TorqueLevel.Low : TorqueLevel.High;
};

export const detectLabelPatterns = (
    blade: RoundDamperBlades,
    torqueLevel: TorqueLevel,
    type: ActuatorTypes,
): string[] => {
    if (blade === RoundDamperBlades.BladeWithSeals) {
        if (torqueLevel === TorqueLevel.Low) {
            switch (type) {
                case ActuatorTypes.NonFailSafe:
                    return ['LM'];
                case ActuatorTypes.FailSafe:
                    return ['LF'];
                case ActuatorTypes.HarshEnvironment:
                    return ['NM%P', 'NF%G'];
                case ActuatorTypes.Fast:
                    return ['LMC', 'LMQ', 'NKQ'];
                default:
                    return [];
            }
        }
        switch (type) {
            case ActuatorTypes.NonFailSafe:
                return ['NM%'];
            case ActuatorTypes.FailSafe:
                return ['NF'];
            case ActuatorTypes.HarshEnvironment:
                return ['NM%P', 'NF%G'];
            case ActuatorTypes.Fast:
                return ['NMQ', 'NMC', 'NMD', 'NKQ'];
            default:
                return [];
        }
    }
    if (torqueLevel === TorqueLevel.Low) {
        switch (type) {
            case ActuatorTypes.NonFailSafe:
                return ['CM%'];
            case ActuatorTypes.FailSafe:
                return ['TF'];
            case ActuatorTypes.HarshEnvironment:
                return ['NM%P', 'NF%G'];
            case ActuatorTypes.Fast:
                return ['TMC', 'LMQ', 'NKQ'];
            default:
                return [];
        }
    }
    switch (type) {
        case ActuatorTypes.NonFailSafe:
            return ['LM%'];
        case ActuatorTypes.FailSafe:
            return ['LF'];
        case ActuatorTypes.HarshEnvironment:
            return ['NM%P', 'NF%G'];
        case ActuatorTypes.Fast:
            return ['LMC', 'LMQ', 'NKQ'];
        default:
            return [];
    }
};

export const handleRoundEuNonLinear = (
    searchParams: URLSearchParams,
    inputState: UserInput,
    selectedActuatorType: ActuatorTypes,
): string => {
    if (inputState.roundDumper === null) {
        return '';
    }
    try {
        const torqueLevel = detectTorqueLevel(inputState.areaOrDiameter, inputState.safety, inputState.roundDumper);
        const caseOne = detectLabelPatterns(inputState.roundDumper, torqueLevel, selectedActuatorType);
        if (caseOne.length > 0) {
            searchParams.set(QueryParams.labels, JSON.stringify(caseOne));
        } else {
            searchParams.delete(QueryParams.labels);
        }
        return caseOne.join(', ');
    } catch {
        searchParams.delete(QueryParams.labels);
        return '';
    }
};
